import { motion } from "framer-motion";
import { MessageCircle } from "lucide-react";
import { useLang } from "@/i18n";
import { waLink } from "@/api";

export default function Host({ config }) {
  const { t } = useLang();
  const wa = config?.whatsapp || "40721663181";

  return (
    <section className="py-24 md:py-32 bg-cream-light border-y border-warm-grey/30" data-testid="host-section">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12">
        <div className="grid lg:grid-cols-12 gap-12 items-center">
          <div className="lg:col-span-7 order-2 lg:order-1">
            <motion.p initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.8 }}
              className="text-xs md:text-sm tracking-[0.25em] uppercase font-bold text-walnut flex items-center gap-3">
              <span className="inline-block w-10 h-px bg-terracotta" />
              {t("host.eyebrow")}
            </motion.p>
            <motion.h2 initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.8, delay: 0.1 }}
              className="mt-5 font-serif font-medium text-4xl md:text-5xl leading-[1.08] tracking-tight text-main max-w-2xl" data-testid="host-title">
              {t("host.title")}
            </motion.h2>
            <motion.p initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} viewport={{ once: true }} transition={{ duration: 0.8, delay: 0.2 }}
              className="mt-7 text-base md:text-lg text-brown font-light leading-relaxed max-w-xl">
              {t("host.p1")}
            </motion.p>
            <motion.p initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} viewport={{ once: true }} transition={{ duration: 0.8, delay: 0.3 }}
              className="mt-4 font-serif italic text-xl md:text-2xl text-green-dark max-w-xl">
              {t("host.p2")}
            </motion.p>
            <motion.a
              initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.8, delay: 0.4 }}
              href={waLink(wa, "Bună, Mihai!")} target="_blank" rel="noreferrer"
              data-testid="host-cta"
              className="mt-9 inline-flex items-center gap-2 rounded-full bg-green-dark text-cream-light font-semibold px-7 py-3.5 hover:bg-terracotta transition-colors duration-300"
            >
              <MessageCircle size={18} /> {t("host.cta")}
            </motion.a>
          </div>

          <div className="lg:col-span-5 order-1 lg:order-2">
            <motion.div
              initial={{ opacity: 0, y: 40 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 1 }}
              className="relative"
            >
              <div className="overflow-hidden rounded-3xl border border-warm-grey/40 shadow-xl shadow-main/10">
                <img src="/assets/mihai.jpg" alt="Mihai, gazda Imperfect House, întâmpinându-și oaspeții în curte" className="w-full h-auto" data-testid="host-photo" />
              </div>
              <div className="absolute -bottom-5 right-6 bg-terracotta text-cream-light rounded-2xl px-5 py-4 shadow-xl">
                <p className="font-serif text-2xl leading-none">9,7</p>
                <p className="text-[10px] tracking-[0.15em] uppercase mt-1 opacity-80">{t("rev.host")}</p>
              </div>
            </motion.div>
          </div>
        </div>
      </div>
    </section>
  );
}
